import produce from 'immer';
import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { VideoType } from './types';
import type { IVideoInfoState } from './types';

function makeVideoInfo(type?: VideoType): IVideoInfoState {
  switch (type) {
    case VideoType.BUSINESS:
      return {
        videoType: VideoType.BUSINESS,
        businessCategory: undefined,
        businessName: '',
      };
    case VideoType.PERSONAL:
      return {
        videoType: VideoType.PERSONAL,
        personalCategory: undefined,
        videoPurpose: '',
      };
    default:
      return { videoType: undefined };
  }
}

const reducer: Reducer<IVideoInfoState, ActionType<typeof actions>> = (
  state = makeVideoInfo(undefined),
  action,
) => {
  return produce(state, (draftState) => {
    switch (action.type) {
      case getType(actions.setVideoType):
        if (state.videoType !== action.payload) {
          return makeVideoInfo(action.payload);
        }
        break;
      case getType(actions.setBusinessName):
        draftState.businessName = action.payload;
        break;
      case getType(actions.setVideoPurpose):
        draftState.videoPurpose = action.payload;
        break;
      case getType(actions.setBusinessCategory):
        draftState.businessCategory = action.payload;
        break;
      case getType(actions.setPersonalCategory):
        draftState.personalCategory = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
export type { IVideoInfoState };
